import { useSelector } from 'react-redux';
import styled from 'styled-components';
import partial from 'transmute/partial';
import AttainmentCell from './AttainmentCell';
import CoverageCell from './CoverageCell';
import CoverageRatioCell from './CoverageRatioCell';
import DealRollupCell from './DealRollupCell';
import ForecastCell from './ForecastCell';
import TotalsNameCell from './TotalsNameCell';
import StickyCellForecastColumn from '../styled/StickyCellForecastColumn';
import { DefaultTableColumns } from '../../constants/OverviewTableConstants';
import { getSelectedTeamId } from '../../selectors/overviewSelectors';
import { getDealGrouping } from '../../utils/dealGroupingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const AccentedRow = styled.tr.withConfig({
  displayName: "TotalsRow__AccentedRow",
  componentId: "sc-1fia1vo-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    fontWeight: theme.typography['heading-100'].fontWeight,
    background: theme.color['fill-surface-raised'],
    textAlign: 'right'
  };
});
const TotalsRow = ({
  closedDealGroupingIds,
  columns,
  dealRollupData,
  dealRollupGroupings,
  onClickAttainmentBar,
  onDealCountClick,
  onEditForecastClick,
  onNameCellViewDealsClick,
  rowData
}) => {
  const selectedTeamId = useSelector(getSelectedTeamId);
  const renderNameCell = () => {
    return /*#__PURE__*/_jsx(TotalsNameCell, {
      onNameCellViewDealsClick: onNameCellViewDealsClick,
      rowData: rowData
    }, DefaultTableColumns.NAME);
  };
  const renderAttainmentCell = () => {
    return /*#__PURE__*/_jsx(AttainmentCell, {
      isDetailPage: false,
      onClickAttainmentBar: partial(onClickAttainmentBar, closedDealGroupingIds, selectedTeamId, false),
      rowData: rowData,
      subscreen: "totals-row"
    }, DefaultTableColumns.ATTAINMENT);
  };
  const renderForecastCell = () => {
    return /*#__PURE__*/_jsx(StickyCellForecastColumn, {
      width: 200,
      children: /*#__PURE__*/_jsx(ForecastCell, {
        onEditForecastClick: onEditForecastClick,
        rowData: rowData
      })
    }, DefaultTableColumns.FORECAST);
  };
  const renderCoverageCell = () => {
    return /*#__PURE__*/_jsx(CoverageCell, {
      isDetailPage: false,
      rowData: rowData
    }, DefaultTableColumns.COVERAGE);
  };
  const renderCoverageRatioCell = () => {
    return /*#__PURE__*/_jsx(CoverageRatioCell, {
      coverage: rowData.coverage
    }, DefaultTableColumns.COVERAGE_RATIO);
  };
  const renderDealRollupCell = groupingId => {
    const dealRollupGrouping = getDealGrouping({
      groupingId,
      dealGroupings: dealRollupGroupings
    });
    if (!dealRollupGrouping) {
      return null;
    }
    return /*#__PURE__*/_jsx(DealRollupCell, {
      groupingId,
      key: groupingId,
      dealRollupData,
      onDealCountClick,
      rowData
    });
  };
  const keyToCellRendererMap = {
    [DefaultTableColumns.ATTAINMENT]: renderAttainmentCell,
    [DefaultTableColumns.COVERAGE]: renderCoverageCell,
    [DefaultTableColumns.COVERAGE_RATIO]: renderCoverageRatioCell,
    [DefaultTableColumns.FORECAST]: renderForecastCell,
    [DefaultTableColumns.NAME]: renderNameCell
  };
  return /*#__PURE__*/_jsx(AccentedRow, {
    children: columns.map(column => {
      const renderCell = keyToCellRendererMap[column.value];
      return renderCell !== undefined && column.internal ? renderCell() : renderDealRollupCell(column.value);
    })
  });
};
export default TotalsRow;